import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { AvThemeToggleComponent } from '../../Shared/Components/theme-toggle/theme-toggle.component';
import { AvLanguageDropdownComponent } from '../../Shared/Components/av-language-dropdown/av-language-dropdown.component';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    RouterOutlet,
    TranslateModule,
    AvThemeToggleComponent,
    AvLanguageDropdownComponent,
  ],
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent {
  version = environment.version;
}
